<div class="formgrid full-width h-full">

    <div class="full-field flex md:flex-column align-items-center justify-content-between md:pt-2 md:pb-8 w-full pr-3">
        <div class="flex flex-column md:mb-8 w-full">
            <!--Logged in user name begin-->
            <div class="flex flex-column align-items-center">
                <div
                    class="border-circle overflow-hidden flex justify-content-center align-items-center w-6rem h-6rem bg-red-200">
                    <img
                        class="w-full"
                        *ngIf="profilePictureUserProperty && profilePictureUserProperty.userPropertyValue && profilePictureUserProperty.userPropertyValue.length > 0"
                        [src]="profilePictureUserProperty.userPropertyValue">
                    <div class="font-bold text-2xl text-red-800"
                         *ngIf="!profilePictureUserProperty || !profilePictureUserProperty.userPropertyValue || profilePictureUserProperty.userPropertyValue.length === 0">
                        {{ firstLettersOfUserName }}
                    </div>
                </div>
                <div class="mt-1 text-xl font-bold">
                    {{ currentUser }}
                </div>
                <!--log out and faq buttons begin-->
                <div class="w-full flex justify-content-between mt-2">
                    <button
                        (click)="logout()"
                        class="text-red-800 w-full py-2 hover:underline border-none cursor-pointer bg-transparent flex align-items-center justify-content-center">
                        <span>{{ 'sipo.log-out' | translate }}</span>
                    </button>
                </div>
                <!--log out and faq buttons end-->
            </div>
            <!--Logged in user name end-->

            <p-divider></p-divider>
            <div *ngIf="!appConfig.onpremise" class="text-sm mt-3">
                <p class="flex no-line-breaks">
                    <span class="font-bold">Ihr Paket:</span>
                    <span>&nbsp;</span>

                    <a [routerLink]="['/payment']" [queryParams]="{ purchaseType: 'subscriptionPayment' }">
                        <div class="font-bold text-cyan-400 text-s">
                            {{ userSubscription?.plan | uppercase }}
                        </div>
                    </a>
                </p>
                <div class="mb-3">
                    <p-button
                              class="hover:underline text-cyan-400 p-0 bg-transparent border-none cursor-pointer"
                              (click)="openPaymentComponent('subscriptionPayment', false)">
                        {{ 'sipo.upgrade-your-plan'|translate }} {{ userSubscription?.plan | uppercase }} {{ 'sipo.plan'|translate }}
                    </p-button>
                </div>
                <div class="mt-2" *ngIf="userSubscription?.plan?.toLowerCase() === 'starter'">
                    <div>
                        <i class="pi pi-clock font-bold text-lg"></i> &nbsp;
                        <span>{{ 'sipo.trial-period-ends'|translate }}
                            <span class="font-bold">
                                    {{ calculateDaysLeft(userSubscription.testStartDate, userSubscription.testDuration) }}
                                </span>
                            {{ 'sipo.trial-period-in-days'|translate }}
                           </span>
                    </div>
                    <div class="flex justify-content-center"
                         *ngIf="userSubscription?.plan === 'Starter' && trialDaysLeft <= 0">
                        {{ 'sipo.your-trial-ended'|translate }}
                    </div>
                </div>



                <p *ngIf="userSubscription?.plan === 'Business'" class="font-bold">
                    Monatskontingent: {{ signsUsed }}/{{ signsAvailable }} Signaturen
                </p>
                <p *ngIf="userSubscription?.plan === 'Business'" class="font-bold">
                    <span>Ihr Guthaben: {{ userSubscription.credit | currencyFormat }}</span>
                </p>
                <p *ngIf="userSubscription?.plan === 'Business'">
                    <button
                        class="p-button mt-0"
                        (click)="openPaymentComponent('creditPayment', false)">
                        {{ 'sipo.credit'|translate }} +
                    </button>
                </p>
            </div>
            <!--user subscription info begin-->
            <div class="w-full mb-3">

                <!--<button (click)="updateSubs('Starter')">STARTER</button>-->

                <div class="py-1" *ngIf="userSubscription">
                    <!--                    <div class="flex align-items-center justify-content-between">-->
                    <!--                        <a [routerLink]="['/payment']" [queryParams]="{ purchaseType: 'subscriptionPayment' }">-->
                    <!--                            <div class="font-bold text-cyan-400 text-lg" *ngIf="userSubscription?.plan === 'Business'">-->
                    <!--                                &lt;!&ndash;                                {{ userSubscription?.plan | uppercase }}&ndash;&gt;-->
                    <!--                                <br> {{ userSubscription.credit | currencyFormat }}-->
                    <!--                            </div>-->
                    <!--                        </a>-->

                    <!--                    </div>-->
                    <!--                    <button *ngIf="userSubscription?.plan != 'Business'"-->
                    <!--                            class="hover:underline text-cyan-400 p-0 bg-transparent border-none cursor-pointer"-->
                    <!--                            (click)="openPaymentComponent('subscriptionPayment', false)">-->
                    <!--                        {{ 'sipo.upgrade-your-plan'|translate }} {{ userSubscription?.plan | uppercase }} {{ 'sipo.plan'|translate }}-->
                    <!--                    </button>-->

                </div>
            </div>
            <!--user subscription info end-->
            <p>&nbsp;</p>
            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold mt-2"
                [ngClass]="{'hover-bg': selectedContent === 'home'}"
                (click)="changeRightContent('home')">
                <span class="custom-text text-base">{{ 'sipo.document' | translate }}</span>
                <i class="p-2 pi pi-file"></i>
            </button>

            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                [ngClass]="{'hover-bg': selectedContent === 'profile-data'}"
                (click)="changeRightContent('profile-data')">
                <span class="custom-text text-base">{{ 'sipo.profile-data' | translate }}</span>
                <i class="p-2 pi pi-user"></i>
            </button>

            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                [ngClass]="{'hover-bg': selectedContent === 'signature-standards'}"
                (click)="changeRightContent('signature-standards')">
                <span class="custom-text text-base">{{ 'sipo.signature-standards' | translate }}</span>
                <i class="p-2 pi pi-id-card"></i>
            </button>

            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                [ngClass]="{'hover-bg': selectedContent === 'visual-signature'}"
                (click)="changeRightContent('visual-signature')">
                <span class="custom-text text-base">{{ 'sipo.visual-signature' | translate }}</span>
                <i class="p-2 pi pi-microchip"></i>
            </button>

            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                [ngClass]="{'hover-bg': selectedContent === 'signature-settings'}"
                (click)="changeRightContent('signature-settings')">
                <span class="custom-text text-base">{{ 'sipo.settings' | translate }}</span>
                <i class="p-2 pi pi-cog"></i>
            </button>

            <button
                class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                [ngClass]="{'hover-bg': selectedContent === 'faq'}"
                (click)="changeRightContent('faq')">
                <span class="custom-text text-base">{{ 'sipo.faq' | translate }}</span>
                <i class="p-2 pi pi-question-circle"></i>
            </button>

            <!--            <button
                            class="flex justify-content-between align-items-center border-round-xl bg-transparent border-none top-buttons-signature py-2 mb-1 text-color-secondary text-left font-bold"
                            [ngClass]="{'hover-bg': selectedContent === 'onboarding'}"
                            (click)="openOnboardingDynamicDialog(true)">
                            <span class="custom-text text-base">Onboarding Info</span>
                            <i class="p-2 pi pi-question-circle"></i>
                        </button>-->
        </div>
    </div>
</div>
